










































import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

@Component
export default class DeleteSurveyPopup extends Vue {
  @Prop() popupId!: string;
  @Prop() catalogue!: any;
  @Prop() brandId!: number

  deleteLocationCatalogue () {
    let popupCloseButton: HTMLElement = this.$refs.popupCloseButton as HTMLElement
    this.$store.dispatch('deleteLocationCatalogue', { brandId: this.brandId, catalogueId: this.catalogue.id }).then(() => {
      this.$emit('deleted')
      popupCloseButton.click()
      this.$notify({ type: 'success', text: 'Store Cluster has been deleted successfully!' })
    }, () => popupCloseButton.click())
  }
}
